import React from 'react';
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';

//const root = 
ReactDOM.createRoot(document.getElementById('root')).render(
 <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>
);


//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);
